<template>
   <div>
      <transition name="fade">
         <b-container v-if="categories && categories.length > 1" fluid class="shop-header"
                      :class="{ 'shop-header--hidden': !showHeader }">
            <shop-navbar v-if="isDesktop"></shop-navbar>
            <shop-navbar-mobile v-else></shop-navbar-mobile>
         </b-container>
      </transition>
      <div class="shop-content-wrapper">
         <transition name="fade">
            <router-view class="shop-content"/>
         </transition>
      </div>
      <footer-component/>
      <cookie-info/>
   </div>
</template>

<script>

// @ is an alias to /src


import {mapActions, mapGetters, mapState} from "vuex";
import Footer from "./components/layout/Footer";
import NavbarMobile from "./components/layout/header/NavbarMobile";
import Navbar from "./components/layout/header/Navbar";
import CookieInfo from "./components/CookieInfo";

export default {
   name: 'shopHome',
   components: {
      'shop-navbar': Navbar,
      'shop-navbar-mobile': NavbarMobile,
      'footer-component': Footer,
      'cookie-info': CookieInfo
   },
   data() {
      return {
         showHeader: true,
         lastScrollPosition: 0
      }
   },
   mounted() {
      window.addEventListener('scroll', this.onScroll)
   },
   beforeDestroy() {
      window.removeEventListener('scroll', this.onScroll)
   },
   methods: {
      ...mapActions('categoryManagement', ['fetchAllCategories']),
      ...mapActions("shopContent", ["fetchNavItems", "fetchFooterItems"]),
      ...mapActions("cart", ["fetchCart"]),
      ...mapActions("sample", ["fetchSampleList"]),
      ...mapActions("favorites", ["fetchFavorites"]),
      ...mapActions("account", ["fetchConferenceList"]),
      onScroll() {
         const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
         if (currentScrollPosition < 0) {
            return
         }

         if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
            return
         }
         this.showHeader = currentScrollPosition < this.lastScrollPosition;
         this.lastScrollPosition = currentScrollPosition
      }
   },
   created() {
      if (this.user) {
         if (this.user.externalData && window.LiveChatWidget) {
            window.LiveChatWidget.call('set_customer_name', this.user.firstName + " " + this.user.lastName);
            window.LiveChatWidget.call('set_customer_email', this.user.email);
         }
         this.fetchCart();
         this.fetchConferenceList();
         this.fetchSampleList();
         this.fetchFavorites();
      }
      this.fetchAllCategories();
      this.fetchNavItems();
      this.fetchFooterItems();
   },
   computed: {
      ...mapState("account", ["user"]),
      ...mapState('categoryManagement', ['categories']),
      ...mapState('shopContent', ['navItems']),
      ...mapState('error', ['globalErrors']),
      ...mapGetters('media', ['isDesktop']),
   }
}
</script>

<style lang="scss">
@import '~@shared/_assets/scss/app.scss';

.shop-header {
   font-family: $font-robo;
   font-weight: 500;
   letter-spacing: 0.33px;
   padding-top: 30px;
   padding-bottom: 30px;
   left: 0;
   right: 0;
   background: white;
   position: fixed;
   top: 0;
   z-index: 999;
   transform: translate3d(0, 0, 0);
   transition: 0.5s all ease-out;

   &.shop-header--hidden {
      box-shadow: none;
      transform: translate3d(0, calc(-100% - 20px), 0);
   }

   @include media-breakpoint-down(md) {
      padding-top: 20px;
      padding-bottom: 15px;
   }

   .nav-item {
      &.active > a {
         font-weight: 500;
      }
   }

   a.header-nav-item, ul.header-nav-list a {
      font-size: 15px;
      font-weight: 300;
      font-family: $font-robo;
      letter-spacing: 0.33px;

      &.active {
         font-weight: 500;
      }

      &.small {
         font-size: 13px;
      }

      &:hover, &:focus {
         font-weight: 500;
         letter-spacing: 0.23px;
      }
   }

   .dropdown-category-menu {
      min-width: 340px;
      padding: 20px;

      .dropdown-category-menu-scroller {
         overflow-y: auto;
         max-height: 520px;
         @include media-breakpoint-down(md) {
            max-height: 320px;
         }

         .header-nav-list {
            margin-right: 5px;
         }
      }
   }

   .logo {
      z-index: 99;
      position: absolute;
      left: 50%;
      margin-left: -47px;
      top: -35px;

      @include media-breakpoint-down(md) {
         margin: auto;
         left: 10px;
         top: -10px;
      }
   }
}

.shop-content {
   padding-top: 85px;

   @include media-breakpoint-down(md) {
      padding-top: 60px;
   }

   min-height: 800px;
   position: relative;
}

.shop-content-wrapper {
   min-height: 200px;
   position: relative;
}
</style>